import { useEffect } from 'react';
import SelectionStep from './SelectionStep';
import { SelectionStepProps } from './SelectionStep';
import selectionStepsMap, { SelectionStepExtendedConfig } from './selectionStepsConfigs';
import useFetchData from '../../hooks/useFetchData';
import Loader from '../../reusable/Loader';
import useUploadCardData from '../../hooks/useUploadCardData';
import CustomButton from '../../reusable/CustomButton';
import ErrorIcon from '../../assets/data-upload-x-mark.svg';

import './InitializeSelectionStep.css';

interface InitialSelectionStepProps extends Omit<SelectionStepProps, 'data'> {
  fetchData: SelectionStepExtendedConfig['fetchData'];
  updateCachedData: (cacheData: string[]) => void;
  getDataLabels?: (data: string[] | any[]) => string[];
}
const InitializeSelectionStep = ({
  selectionStepKey,
  selectionStepLabel,
  fetchData,
  handleChangeStep,
  selectedData,
  updateCachedData,
  handleSelection,
  getDataLabels,
}: InitialSelectionStepProps) => {
  const { isPending, error, data } = useFetchData({
    fetchData: fetchData,
    errorMessage: '',
    options: {
      disableErrorModal: true,
    },
    initialState: [],
  });
  const { fileType, handleClose, triggerFileSelect } = useUploadCardData();

  const dataLabels = getDataLabels ? getDataLabels(data) : (data as string[]);

  const handleReupload = () => {
    handleClose();
    triggerFileSelect();
  };

  useEffect(() => {
    if (error) {
      let stepsLength = selectionStepsMap[fileType].selectionSteps.length;
      handleChangeStep(stepsLength - 1);
    }
  }, [error]);

  if (isPending) return <Loader />;

  if (error) {
    return (
      <div className="upload-prompt-error-message">
        <div className="error-message-text">
          <img src={ErrorIcon} alt="exclamation mark icon"></img>
          <p className="no-margin">There’s been a system error. Wait a few minutes and try again.</p>
        </div>
        <div className="error-message-actions">
          <CustomButton variant="secondary" size="medium" buttonText="Cancel" buttonAction={handleClose} />
          <CustomButton variant="primary" size="medium" buttonText="Upload" buttonAction={handleReupload} />
        </div>
      </div>
    );
  }

  updateCachedData(dataLabels);

  return (
    <SelectionStep
      data={dataLabels}
      selectedData={selectedData}
      selectionStepKey={selectionStepKey}
      selectionStepLabel={selectionStepLabel}
      handleChangeStep={handleChangeStep}
      handleSelection={handleSelection}
    />
  );
};

export default InitializeSelectionStep;
